import { Link } from "react-router-dom";
import { ArrowRight, Building2, UserRound } from "lucide-react";

const choices = [
  {
    to: "/employee/login",
    title: "Employee",
    body: "Tasks, leave, hours, and your own record.",
    icon: UserRound,
  },
  {
    to: "/employer/login",
    title: "Employer",
    body: "People, approvals, awards, and organization settings.",
    icon: Building2,
  },
];

export default function HomePage() {
  return (
    <main className="grid min-h-[100dvh] lg:grid-cols-2">
      <section className="flex flex-col gap-8 bg-primary px-6 py-8 text-primary-foreground lg:justify-between lg:px-14 lg:py-10">
        <p className="text-sm font-medium tracking-wide text-white/80">ISKCON Pune · BCEC</p>
        <div className="max-w-md lg:py-16">
          <h1 className="text-4xl font-semibold tracking-tight">HR portal</h1>
          <p className="mt-4 text-lg leading-relaxed text-white/85">
            One place for people, leave, hours, and the work of the day.
          </p>
        </div>
        <p className="text-sm text-white/70">Attendance punches stay on the biometric portal.</p>
      </section>
      <section className="flex items-center justify-center bg-background px-6 py-8 lg:py-12">
        <div className="w-full max-w-md space-y-3">
          <h2 className="text-lg font-semibold">Sign in as</h2>
          {choices.map(({ to, title, body, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              className="flex min-h-11 cursor-pointer items-center gap-4 rounded-xl border bg-card p-4 shadow-sm transition-colors hover:border-primary/40 hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-medium">{title}</span>
                <span className="mt-0.5 block text-sm text-muted-foreground">{body}</span>
              </span>
              <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
